<div class="PGFileList PGFileList--{{getLayoutMode()}} {{selectionMode != null ? 'PGFileList--Selectable' : ''}}">
    @if (isRunningOperation) {
        <app-pg-loading [isOverlay]="true" [progressRatio]="isRunningOperationProgress"></app-pg-loading>
    }

    <div class="PGFileList-Buttons px-2 mx-1">
        @if (hasViewModeSelection()) {
            <div class="btn-group pb-3">
                @for (type of [null,'images','audios','videos','documents']; track type) {
                    <div class="btn {{viewMode == type ? 'btn-primary' : 'btn-secondary' }}" (click)="setViewMode(type)">
                        <i class="fa-regular {{getCategoryIcon(type)}}"></i>
                        <span class="PGFileList-Buttons-Text">{{ 'pg-resource-view-file.type-' + (type || 'all') | locTranslate }}</span>
                    </div>
                }
            </div>
        }
        <!-- TODO: QUA CI VANNO DRAFT? -->
        @if (selectionMode == null && actions.create) {
            <div class="pb-3">
                <button class="btn btn-primary" (click)="createFile()">
                    <span>{{ 'pg-resource-view-file.upload-resource' | locTranslate }}</span>
                    <i class="fa-regular fa-upload"></i>
                </button>
            </div>
        }
    </div>

    @if (hasDirectoriesNavigation()) {
        <div class="PGFileList-Navigation px-3 mx-1">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <nav>
                    <ol class="breadcrumb align-items-center mb-0">
                        @if (getFilterSearch(); as search) {
                            <li class="breadcrumb-item">
                                <i class="fa-regular fa-search me-2"></i>
                                <span>{{ 'pg-resource-view-file.directory-search' | locTranslate }} "{{search}}"</span>
                            </li>
                        }
                        @if (getFilterTags(); as tags) {
                            <li class="breadcrumb-item">
                                <i class="fa-regular fa-hashtag me-2"></i>
                                <span>{{ 'pg-resource-view-file.directory-tags' | locTranslate }} "{{tags}}"</span>
                            </li>
                        }
                        @if (getFilterSystemTags(); as system_tags) {
                            <li class="breadcrumb-item">
                                <i class="fa-regular fa-hashtag-lock me-2"></i>
                                <span>{{ 'pg-resource-view-file.directory-system_tags' | locTranslate }} "{{getSystemTagsLabel(system_tags)}}"</span>
                            </li>
                        }
                        @if (getFilterCategories(); as categories) {
                            <li class="breadcrumb-item">
                                <i class="fa-regular fa-list me-2"></i>
                                <span>{{ 'pg-resource-view-file.directory-categories' | locTranslate }} "{{getCategoriesLabel(categories)}}"</span>
                            </li>
                        }
                        @if (hasSearchOrTagsOrCategories()) {
                            <li class="mx-2">
                                <app-pg-select [ngModel]="searchAllValue ? 'true' : 'false'" (ngModelChange)="setSearchAllValue($event)" [options]="searchAllOptions" [required]="true" display="oneLine"></app-pg-select>
                            </li>
                        }
                        @if (!hasSearchOrTagsOrCategories() || !searchAllValue) {
                            <li class="breadcrumb-item">
                                /&nbsp;
                                @if (currentDirectory == null) {
                                    <span>{{ 'pg-resource-view-file.directory-root' | locTranslate }}</span>
                                }
                                @if (currentDirectory != null) {
                                    <a href="javascript:void(0)" (click)="goToDirectory(null)">{{ 'pg-resource-view-file.directory-root' | locTranslate }}</a>
                                }
                            </li>
                            @for (directory of currentDirectoryPath; track directory) {
                                <li class="breadcrumb-item {{ directory == currentDirectory ? 'active' : '' }}">
                                    @if (directory == currentDirectory) {
                                        <span>{{directory.label}}</span>
                                    }
                                    @if (directory != currentDirectory) {
                                        <a href="javascript:void(0)" (click)="goToDirectory(directory)">{{directory.label}}</a>
                                    }
                                </li>
                            }
                        }
                    </ol>
                </nav>
                @if (selectionMode == null && !hasSearchOrTagsOrCategories()) {
                    <div class="d-flex align-items-center">
                        @if (currentDirectory != null) {
                            <div>
                                <button class="btn btn-link" (click)="downloadDirectory()">
                                    <span>{{ 'pg-resource-view-file.directory-download' | locTranslate }}</span><i class="fa-regular fa-download"></i>
                                </button>
                            </div>
                        }
                        <div class="ms-2">
                            <button class="btn btn-link" (click)="setShowCreateDirectory(true)">
                                <span>{{ 'pg-resource-view-file.directory-create' | locTranslate }}</span><i class="fa-regular fa-folder-plus"></i>
                            </button>
                        </div>
                    </div>
                }
            </div>
            @if (selectionMode == null && !hasSearchOrTagsOrCategories()) {
                <div class="PGFileList-Navigation-Selection d-flex align-items-center justify-content-end mb-3">
                    @if (getEditSelectionCount()) {
                        <div class="ms-2">
                            <button class="btn btn-link" [disabled]="!editSelectionCanMoveHere()" (click)="editSelectionDoMoveHere()">
                                <span>{{ 'pg-resource-view-file.edit-selection-move-here' | locTranslate }}</span>
                                <i class="fa-regular fa-folder-arrow-down"></i>
                            </button>
                        </div>
                        <div class="ms-2 bg-white ps-2 rounded border-white d-flex align-items-center" [ngbTooltip]="editSelectionGetTooltip()">
                            <span class="ps-1">
                                @if (editSelection.directories.length) {
                                    <span>{{ 'pg-resource-view-file.edit-selection-count-directories' | locTranslate:'count':editSelection.directories.length }}</span>
                                }
                                @if (editSelection.directories.length && editSelection.files.length) {
                                    <span>, </span>
                                }
                                @if (editSelection.files.length) {
                                    <span>{{ 'pg-resource-view-file.edit-selection-count-files' | locTranslate:'count':editSelection.files.length }}</span>
                                }
                            </span>
                            <button class="btn btn-link text-danger border-0" (click)="editSelectionReset()">
                                <i class="fa-regular fa-times"></i>
                            </button>
                        </div>
                    }
                    <div class="ms-2">
                        <button class="btn btn-{{ editSelectionMode ? 'primary' : 'link' }}" (click)="editSelectionMode = !editSelectionMode">
                            <span>{{ 'pg-resource-view-file.edit-selection-toggle' | locTranslate }}</span>
                            <i class="fa-regular fa-square-check"></i>
                        </button>
                    </div>
                </div>
            }
        </div>
    }

    <div class="bg-white PGFileList-Main">
        @if (hasDirectoriesNavigation()) {
            <div class="border-bottom PGFileList-Directory container-fluid">
                <div class="row pb-3">
                    @if (isLoadingDirectoryData) {
                        @if (currentDirectoryList == null) {
                            <div class="PGFileList-Directory-Loading mt-3">
                                <app-pg-loading [progressRatio]="isLoadingDirectoryDataProgress"></app-pg-loading>
                            </div>
                        }
                        @if (currentDirectoryList != null) {
                            <app-pg-loading [isOverlay]="true" [progressRatio]="isLoadingDirectoryDataProgress"></app-pg-loading>
                        }
                    }
                    @if (currentDirectoryList != null) {
                        @if (showCreateDirectory) {
                            <div class="PGFileList-Directory-Element col-12 col-lg-6 col-xl-4 pt-3">
                                <div class="d-flex align-items-center h-100">
                                    <input #createDirectoryInput class="form-control form-control-sm" placeholder="{{ 'pg-resource-view-file.directory-create' | locTranslate }}" [(ngModel)]="createDirectoryLabel" (blur)="setShowCreateDirectory(false, true)">
                                    <button class="btn btn-sm btn-primary ms-1" [disabled]="!canCreateDirectory()" (click)="createDirectory()">
                                        <i class="fa-regular fa-plus"></i>
                                    </button>
                                </div>
                            </div>
                        }
                        @if (!showCreateDirectory && currentDirectoryList.length == 0) {
                            <div class="PGFileList-Directory-NoDirectories col-12 pt-3 text-muted">
                                {{ 'pg-resource-view-file.directory-no-directories' | locTranslate }}
                            </div>
                        }
                        @for (directory of currentDirectoryList; track directory) {
                            <div class="PGFileList-Directory-Element col-12 col-lg-6 col-xl-4 pt-3">
                                <div class="bg-light d-flex align-items-center {{ isEditSelected(directory) ? 'shadow-highlight' : ''}}">
                                    @if (editSelectionMode) {
                                        <div class="ps-2">
                                            <input type="checkbox" [ngModel]="isEditSelected(directory)" (ngModelChange)="setEditSelected(directory, $event)">
                                        </div>
                                    }
                                    <div class="PGFileList-Directory-Element-Display" (click)="goToDirectory(directory)">
                                        <i class="fa-regular fa-folder"></i>
                                        <div class="PGFileList-Directory-Element-Display-Text ps-2 {{currentRenameDirectory == directory ? 'PGFileList-Directory-Element-Display-Text--Renaming' : ''}}">
                                            <div class="-Name">
                                                @if (currentRenameDirectory != directory) {
                                                    <a href="javascript:void(0)">{{directory.label}}</a>
                                                }
                                                @if (currentRenameDirectory == directory) {
                                                    <div class="pe-1">
                                                        <input #renameDirectoryInput class="form-control form-control-sm" [(ngModel)]="currentRenameDirectoryLabel" (blur)="checkDoCurrentRenameDirectory()" (change)="checkDoCurrentRenameDirectory()">
                                                    </div>
                                                }
                                            </div>
                                            <!-- TODO: completare questa parte per visualizzare il path durante le ricerche
                                            <div *ngIf="hasSearchOrTagsOrCategories()" class="PGFileList-Directory-Element-Display-Text-Path">
                                                <small class="text-muted">{{directory.pathLabels}}</small>
                                            </div>
                                            -->
                                        </div>
                                    </div>
                                    <div>
                                        @if (selectionMode == null) {
                                            <app-pg-resource-element-menu resourceId="Directory" [elementId]="directory.id" [elementData]="directory" (dataChange)="checkDirectoryPropagateChanges($event)"
                                                [customActions]="directoryCustomActions" (customActionRun)="renameDirectory(directory)">
                                                <div afterEdit>
                                                    <div class="dropdown-divider"></div>
                                                    <div class="dropdown-item d-flex justify-content-between" (mousedown)="$event.stopPropagation()" (click)="directoryPropagateChanges = !directoryPropagateChanges;">
                                                        <div>
                                                            <i class="fa-regular fa-diagram-project"></i><span>{{ 'pg-resource-view-file.directory-propagate-changes' | locTranslate }}</span>
                                                        </div>
                                                        <div class="ps-2">
                                                            <app-pg-switch [small]="true" color="danger" [ngModel]="directoryPropagateChanges"></app-pg-switch>
                                                        </div>
                                                    </div>
                                                </div>
                                            </app-pg-resource-element-menu>
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                    }
                </div>
            </div>
        }

        <div class="PGFileList-Scrollable container-fluid">
            <div class="row pb-3">
                @if (isAtEnd && dataRows.length == 0) {
                    <div class="PGFileList-Directory-NoFiles col-12 pt-3 text-muted">
                        {{ 'pg-resource-view-file.directory-no-files' | locTranslate }}
                    </div>
                }

                @for (file of dataRows; track file) {
                    <div class="PGFileList-Element col-12 col-lg-6 col-xl-4 pt-3 pg-animation-slidedown {{file.progress != null ? 'PGFileList-Element--Uploading' : ''}}" [appPgAnimations]="file.deleted ? 'ExitT' : ''" (click)="toggleSelection(file)">
                        <div class="PGFileList-Element-Progress bg-light">
                            <app-pg-loading [progressVal]="file.progress" [hasError]="file.error"></app-pg-loading>
                        </div>
                        <div class="PGFileList-Element-Preview bg-light {{isSelected(file) || isEditSelected(file) ? 'shadow-highlight' : ''}} d-flex align-items-center">
                            @if (editSelectionMode) {
                                <div class="ps-2">
                                    <input type="checkbox" [ngModel]="isEditSelected(file)" (ngModelChange)="setEditSelected(file, $event)">
                                </div>
                            }
                            <div class="PGFileList-Element-Preview-Display">
                                <app-pg-file-preview [fileData]="file" [viewMode]="viewMode"></app-pg-file-preview>
                            </div>
                            <div class="PGFileList-Element-Preview-Options {{currentRenameFile == file ? 'PGFileList-Element-Preview-Options--Renaming' : ''}} {{ viewMode == null || viewMode == 'documents' ? 'PGFileList-Element-Preview-Options--HasIcon' : ''}}">
                                @if (currentRenameFile == file) {
                                    <div class="PGFileList-Element-Preview-Options-Rename pe-1">
                                        <input #renameFileInput class="form-control form-control-sm" [(ngModel)]="currentRenameFileName" (blur)="checkDoCurrentRenameFile()" (change)="checkDoCurrentRenameFile()">
                                    </div>
                                }
                                <div>
                                    @if (selectionMode == null) {
                                        <app-pg-resource-element-menu [resourceId]="resourceId" [elementId]="file.id" [elementData]="file" (dataChange)="reset()">
                                            <div beforeEdit>
                                                @if (actions.edit) {
                                                    <button class="dropdown-item btn" (click)="renameFile(file)">
                                                        <i class="fa-regular fa-i-cursor"></i><span>{{ 'pg-resource-view-file.file-rename' | locTranslate }}</span>
                                                    </button>
                                                }
                                            </div>
                                            <div afterEdit>
                                                <button class="dropdown-item btn" (click)="downloadFile(file)">
                                                    <i class="fa-regular fa-download"></i><span>{{ 'pg-resource-view-file.file-download' | locTranslate }}</span>
                                                </button>
                                            </div>
                                        </app-pg-resource-element-menu>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>

            <div class="PGFileList-Footer">
                <app-pg-view-more [hidden]="isLoadingData || isAtEnd" (viewMore)="loadData()"></app-pg-view-more>
                @if (isLoadingData) {
                    <div class="PGFileList-Footer-Loading pg-animation-fadein">
                        <app-pg-loading></app-pg-loading>
                    </div>
                }
            </div>
        </div>
    </div>
</div>